import * as types from './editionsActionTypes';

const initialState = {
    previous: [],
    next: [],
    current: {},
    errorMessage: '',
    errorCode:'',
    specificEditionRetrieved : false,
    specificEditionRetrievalInProgress : false,
    showBlockedChatPopup: false,
};

const setEditions = (state, action) => {
    const { previous, next, current } = action;
    return {
        ...state, 
        previous,
        next,
        current
    }
};

const setEditionsFailed = (state, action) => {
    const { errorMessage } = action;
    return {
        ...state,
        errorMessage
    }
};

const getSpecificEditionStart = (state, action) => {
    return {
        ...state,
        specificEditionRetrievalInProgress : true,
    }
}

const getSpecificEditionSuccess = (state, action) => {
    const { previous, next, current } = action;
    return {
       ...state,
       previous, 
       next, 
       current,
       specificEditionRetrieved : true,
       specificEditionRetrievalInProgress : false,
   };
}

const getSpecificEditionFail = (state, action) => {
    const { errorMessage, errorCode } = action;
    return {
       ...state,
       errorMessage,
       errorCode,
       specificEditionRetrievalInProgress : false,
       specificEditionRetrieved : false,
   };
}

const showBlockedChatPopup = (state, action) => {
    return {
        ...state,
        showBlockedChatPopup : true,
    }
}

const hideBlockedChatPopup = (state, action) => {
  return {
      ...state,
      showBlockedChatPopup : false,
  }
}

export const editions = (state = initialState, action) => {
    switch(action.type) {
        case types.SET_EDITIONS:                        return setEditions(state, action);
        case types.SET_EDITIONS_FAILED:                 return setEditionsFailed(state, action);
        case types.RETRIEVE_SPECIFIC_EDITION_START:     return getSpecificEditionStart(state, action);
        case types.RETRIEVE_SPECIFIC_EDITION_SUCCESS:   return getSpecificEditionSuccess(state, action);
        case types.RETRIEVE_SPECIFIC_EDITION_FAIL:      return getSpecificEditionFail(state, action);
        case types.SHOW_BLOCKED_CHAT_POPUP:             return showBlockedChatPopup(state, action);
        case types.HIDE_BLOCKED_CHAT_POPUP:             return hideBlockedChatPopup(state, action);
        default:                            return state;
    }
}

export default editions;


// WEBPACK FOOTER //
// ./src/components/Editions/editionsReducers.js